import { AppNavItem } from "@lantern/app/models";

export const appMenu: AppNavItem[] = [];
